var _excluded = ["component", "icon", "label"];

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { alpha, ListItemButton, ListItemIcon, ListItemText, styled } from '@mui/material';
import { SideNavMenuItemSecondary as SideNavMenuItemSecondaryIcon, SideNavMenuItemTertiary as SideNavMenuItemTertiaryIcon } from './index';
import { ListItem } from '../../List';
import { useLeftDrawerState } from '../../AppShell';
import { States } from '../../AppShell/Drawer';
import { useSideNavContext } from '../SideNavMenu'; // Workaround for type docs

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var NAV_ITEM_ACTIVE_CLASSNAME = 'navItemActive';
var Root = styled(ListItemButton, {
  label: 'MnrlPrivateSideNavMenuItem-root'
})(function (_ref) {
  var _hover, _ref2;

  var theme = _ref.theme;
  return _ref2 = {
    border: 0,
    borderRadius: theme.shape.borderRadius,
    minHeight: theme.spacing(4),
    outline: 0,
    padding: 0
  }, _ref2["&." + NAV_ITEM_ACTIVE_CLASSNAME + " > .MuiListItem-root"] = {
    backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity)
  }, _ref2['&.Mui-focusVisible, &:focus-visible'] = {
    backgroundColor: 'transparent',
    outline: 0,
    '& > .MuiListItem-root': theme.mixins.focusRing({
      color: theme.palette.primary.main
    })
  }, _ref2['&:hover'] = (_hover = {
    backgroundColor: 'transparent',
    '& > .MuiListItem-root': {
      backgroundColor: theme.palette.action.hover
    }
  }, _hover["&." + NAV_ITEM_ACTIVE_CLASSNAME + " > .MuiListItem-root"] = {
    backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.hoverOpacity + theme.palette.action.selectedOpacity)
  }, _hover), _ref2;
});
var Inner = styled(ListItem, {
  label: 'MnrlPrivateSideNavMenuItem-inner'
})(function (_ref3) {
  var _extends2;

  var _ref3$ownerState = _ref3.ownerState,
      isDrawerClosed = _ref3$ownerState.isDrawerClosed,
      level = _ref3$ownerState.level,
      theme = _ref3.theme;
  return _extends({}, theme.typography.h6, {
    alignItems: 'center',
    borderRadius: theme.shape.borderRadius,
    color: theme.palette.text.secondary,
    minHeight: theme.spacing(5),
    padding: 0,
    transition: theme.transitions.create('backgroundColor', {
      easing: theme.transitions.easing.easeInOut,
      duration: theme.transitions.duration["short"]
    })
  }, level !== 1 && _extends({
    minHeight: theme.spacing(4)
  }, isDrawerClosed ? {
    justifyContent: 'center',
    marginInline: parseInt(theme.spacing(1)) / 2 // FIXME: Causes shadowing when :active

  } : level === 3 && {
    paddingLeft: theme.spacing(4)
  }), (_extends2 = {}, _extends2["." + NAV_ITEM_ACTIVE_CLASSNAME + " &"] = _extends({}, theme.typography.h5, {
    backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
    color: theme.palette.text.primary
  }), _extends2));
});
var Icon = styled(ListItemIcon, {
  label: 'MnrlPrivateSideNavMenuItem-icon'
})(function (_ref4) {
  var _ref5;

  var _ref4$ownerState = _ref4.ownerState,
      isDrawerClosed = _ref4$ownerState.isDrawerClosed,
      level = _ref4$ownerState.level,
      theme = _ref4.theme;
  return _ref5 = {
    color: theme.palette.text.secondary,
    justifyContent: 'center',
    marginBlock: 0,
    marginRight: 0,
    minWidth: 0,
    pointerEvents: 'none',
    width: theme.spacing(level !== 1 && isDrawerClosed ? 4 : 5)
  }, _ref5["." + NAV_ITEM_ACTIVE_CLASSNAME + " &"] = {
    color: theme.palette.primary.main
  }, _ref5['& > .MuiSvgIcon-root'] = {
    transition: theme.transitions.create('color', {
      easing: theme.transitions.easing.easeInOut,
      duration: theme.transitions.duration["short"]
    })
  }, _ref5;
});
var Label = styled(ListItemText, {
  label: 'MnrlPrivateSideNavMenuItem-label'
})(function (_ref6) {
  var isDrawerClosed = _ref6.ownerState.isDrawerClosed,
      theme = _ref6.theme;
  return isDrawerClosed ? theme.mixins.visuallyHidden : {
    color: 'inherit',
    fontWeight: 'inherit',
    marginTop: -1,
    // Optical alignment
    paddingRight: theme.spacing(1)
  };
});
export var PrivateSideNavMenuItem = /*#__PURE__*/React.forwardRef(function (_ref7, ref) {
  var _ref7$component = _ref7.component,
      component = _ref7$component === void 0 ? 'a' : _ref7$component,
      iconIn = _ref7.icon,
      label = _ref7.label,
      restProps = _objectWithoutPropertiesLoose(_ref7, _excluded);

  var _useLeftDrawerState = useLeftDrawerState(),
      drawerState = _useLeftDrawerState[0].state;

  var isDrawerClosed = drawerState === States.Closed;

  var _useSideNavContext = useSideNavContext(),
      level = _useSideNavContext.level; // prettier-ignore


  var icon = iconIn || [iconIn,
  /*#__PURE__*/
  // eslint-disable-next-line react/jsx-key
  _jsx(SideNavMenuItemSecondaryIcon, {}),
  /*#__PURE__*/
  // eslint-disable-next-line react/jsx-key
  _jsx(SideNavMenuItemTertiaryIcon, {})][level - 1];
  var ownerState = {
    isDrawerClosed: isDrawerClosed,
    level: level
  };
  return /*#__PURE__*/_jsx(Root, _extends({
    component: component,
    "data-drawer-opt-out": true,
    "data-testid": "privateSideNavMenuItem" // TODO: Necessary? Search for `testid` throughout. `id`, too?
    // @ts-ignore
    ,
    ref: ref // @ts-ignore - [1] Unsure how type `event` here. TS expects TouchEvent<DivElement>, but TouchEvent isn't generic?
    ,
    onTouchEnd: function onTouchEnd(event) {
      event.preventDefault();
    } // @ts-ignore [1]
    ,
    onTouchStart: function onTouchStart(event) {
      // @ts-ignore [1]
      event.target.click();
    } // @ts-ignore — [2] MUI doesn't type `null` as valid for attributes
    // eslint-disable-next-line jsx-a11y/aria-role
    ,
    role: null // @ts-ignore — [2]
    ,
    tabIndex: null
  }, restProps, {
    children: /*#__PURE__*/_jsxs(Inner, {
      component: "div",
      disableGutters: true,
      ownerState: ownerState,
      children: [icon && /*#__PURE__*/_jsx(Icon, {
        ownerState: ownerState,
        children: icon
      }), label && /*#__PURE__*/_jsx(Label, {
        ownerState: ownerState,
        primaryTypographyProps: {
          noWrap: true,
          variant: 'inherit'
        },
        children: label
      })]
    })
  }));
});